import React, { useCallback } from 'react';
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
import { User } from '@/features/auth/types/auth.types';
import { PlanUpgradeModal } from './PlanUpgradeModal';

export interface FeatureGateProps {
  featureKey: keyof User['features'] | ((user: User | null) => boolean);
  featureTitle: string;
  requiredPlan?: 'Growth' | 'Pro' | 'Elite' | 'WhatsApp API' | 'Instagram Automation' | string;
  description?: string;
  benefits?: Array<{ title: string; description?: string }>;
  children?: React.ReactNode;
}

export const FeatureGate: React.FC<FeatureGateProps> = ({
  featureKey,
  featureTitle,
  requiredPlan,
  description,
  benefits,
  children,
}) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const context = useOutletContext();

  const isAccessible = typeof featureKey === 'function'
    ? featureKey(user)
    : Boolean(user?.features?.[featureKey]);

  const handleClose = useCallback(() => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  if (!isAccessible) {
    return (
      <PlanUpgradeModal
        isOpen={true}
        onClose={handleClose}
        featureTitle={featureTitle}
        requiredPlan={requiredPlan}
        description={description}
        benefits={benefits}
      />
    );
  }

  if (children) {
    return <>{children}</>;
  }

  return <Outlet context={context} />;
};

export default FeatureGate;
